/**
 * Módulo: Universo Milbrands
 *
 * IMPORTANTE — SIN UI ni route propia (mismo patrón que el módulo `ia`):
 * existe como **ítem contratable del plan**. Un plan lo incluye —o no— en
 * `modulosIncluidos`, eso se denormaliza a `empresas.modulosDisponibles`
 * (sincronizarModulosPlan) y el front gatea con `tieneUniverso(empresa)`
 * (lib cuadroGeneral).
 *
 * Qué habilita: los bloques "Universo Milbrands" del Pulso general — la
 * comparación anónima contra las cuentas de la plataforma (mediana y banda
 * por métrica: facturación, ticket, recurrencia, ACOS, sell-through, etc.).
 * Servicio hermano de `mercado-datos` (17-jul-2026, decisión Mariano: ambos
 * servicios de mercado gateados por plan; en Premium van activos).
 */
export default {
  id: 'universo-milbrands',
  nombre: 'Universo Milbrands',
  descripcion: 'Benchmark anónimo contra las cuentas de la plataforma en el Pulso general (mediana y posición por métrica).',
  icono: 'globe',
  tipo: 'operativo',
  version: '0.1.0',

  // Sin rutas ni menú: vive embebido en el Pulso general.
  routes: [],
  menuItems: [],

  features: ['universo-benchmarks-pulso'],

  // Vacío a propósito: no se gatea por rol — se gatea por plan.
  permisoModulos: [],

}
